module.exports = __webpack_public_path__ + "img/89a263e.png";